export default {
  setNailDesign(state, value) {
    state.nailDesign = value
  },
  setNailDesigns(state, value) {
    state.nailDesigns = value
  },
  setNailDesignTags(state, value) {
    state.nailDesignTags = value
  },
  setNailDesignFilters(state, filters) {
    state.nailDesignFilters = filters
  },
}
